<h2 class="mat-dialog-title" mat-dialog-title class="text-secondary">{{data?.tutor?.is_active ? 'Deactivate' : 'Activate'}}
    Tutor?</h2>
<mat-dialog-content>
    <div>
        <p class="modal-text m-0"></p>
        <span>Are you sure you want to {{data?.tutor?.is_active ? 'deactivate' : 'activate'}}
            {{data?.tutor?.first_name + " " + data?.tutor?.last_name}}?</span>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="dialogRef.close(false)">Cancel</button>
    <button mat-raised-button color="primary" (click)="confirmAction()" cdkFocusInitial>Yes</button>
</mat-dialog-actions>